import React, {useState, useEffect} from 'react';
import api from '../contexts/BaseUrl'
import './MarketDue.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { useCallback } from 'react';


function MarketDue(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    const [assignedTo, setAssignedTo] = useState('');
    const [salesArea, setSalesArea] = useState('');
    const [totalPrice,setTotalPrice] = useState();
    const [personDues, setPersonDues] = useState([]);

  
   //add person due variable
    const [addPersonDue, setAddPersonDue] = useState(0);
    const [personName, setPersonName] = useState('');
    const [personPhone, setPersonPhone] = useState('');
    const [personDueAmount, setPersonDueAmount] = useState();
    const [isDueLoading, setIsDueLoading] = useState(false);
    const [marketDueId, setMarketDueId] = useState(0);
    
    const showAddDue = (e) => {
        setMarketDueId(e);
        setAddPersonDue(1);
    }

    const closeAddPersonDue = () => {
        setPersonName();
        setPersonPhone();
        setPersonDueAmount();
        setMarketDueId();
        setAddPersonDue(0);
    }

    //edit person due variable
    const [editPersonDue, setEditPersonDue] = useState(0);
    const [personDueId, setPersonDueId] = useState(0);
  

  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        url = `marketdues/get-market-dues?salesarea=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}`
    }
    else if(dateFromObj != null && dateToObj != null){
        url = `marketdues/get-market-dues?fromDate=${dateFrom}&toDate=${dateTo}`
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        url = `marketdues/get-market-dues?salesarea=${searchSalesAssignedTo}&fromDate=${dateFrom}`
    }
    else if(dateFromObj != null){
        url = `marketdues/get-market-dues?fromDate=${dateFrom}`
    }
    else if(searchSalesAssignedTo.length>0){
        url = `marketdues/get-market-dues?salesarea=${searchSalesAssignedTo}`
    }
    else{
        url = `marketdues/get-market-dues?pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllSales = useCallback(async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchSaleDetails = (e) => {
        setIsEditLoading(true);
        api.get(`marketdues/get-market-details?marketId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.marketDueId);
            setSelectedDate(response.data.marketDueDate);
            setSalesArea(response.data.marketDueSalesArea);
            setAssignedTo(response.data.marketDueAssignedTo);  
            setTotalPrice(response.data.marketDueAmount);
            setPersonDues(response.data.personDues);

            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    const fetchPersonDueDetails = (e) => {
        setIsEditLoading(true);
        api.get(`persondues/get-person-details?personId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setPersonDueId(response.data.personDueId);
            setPersonName(response.data.personDueName);
            setPersonPhone(response.data.personDuePhone);
            setPersonDueAmount(response.data.personDueAmount);

            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
       fetchAllSales();
    },[fetchAllSales])

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`marketdues/create-market-due`,{
            marketDueDate: selectedDateObj,
            marketDueAssignedTo: assignedTo,
            marketDueSalesArea: salesArea,
            marketDueAmount: totalPrice,
            
        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllSales();
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
         
            setTotalPrice();
     
          
            setAddSale();
            setIsError(false);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
     
            setTotalPrice();
  
        })
    }

    const showEditSale = (e) => {
        fetchSaleDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        setSalesArea('');
        setAssignedTo('');

        setTotalPrice();
  
        setIsEditLoading(false);
        fetchAllSales();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`marketdues/edit-market-due`,{
            marketDueId: saleId,
            marketDueAssignedTo: assignedTo,
            marketDueSalesArea: salesArea,
            marketDueAmount: totalPrice,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
  
            setTotalPrice();
      
            setIsEditLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            //setIsLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
          
            setTotalPrice();
       
        })
    }

    const handleEditPersonDue = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);

        await api.post(`persondues/edit-person-due`, {
            personDueId: personDueId,
            personDueName: personName,
            personDuePhone: personPhone,
            personDueAmount: personDueAmount
        },{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setPersonDueId();
            setPersonName();
            setPersonPhone();
            setPersonDueAmount();
            fetchAllSales();
            setIsEditLoading(false);
            setEditSaleDetails(0);
            setEditPersonDue(0);
        }).catch(err => {
            setIsError(true);
        })
    }    

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`marketdues/delete-market-due`,{
            marketDueId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setTotalPrice();
            setIsDeleteLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setSalesArea('');
            setAssignedTo('');
            setTotalPrice();
        })
    }

    const handleDeletePersonDue = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        
        await api.post(`persondues/delete-person-due`,{
            personDueId: personDueId
        },{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setPersonDueId();
            setPersonName();
            setPersonPhone();
            setPersonDueAmount();

            fetchAllSales();
            setIsDeleteLoading(false);
            setEditSaleDetails(0);
            setEditPersonDue(0);     
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
        })
    }

    // person due api
    const handleAddPersonDue = async (e) => {
        setIsDueLoading(true);
        e.preventDefault();

        await api.post('persondues/create-person-due', {
            personDueName: personName,
            personDuePhone: personPhone,
            personDueAmount: personDueAmount,
            marketDueId: marketDueId
        }, {
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            fetchAllSales();
            setIsDueLoading(false);
            setPersonName('');
            setPersonPhone('');
            setPersonDueAmount();
            setAddPersonDue(0);
        }).catch(err => {
            setIsError(true);
            setIsDueLoading(false);
        })
    }

    const showEditPersonDue = (e) => {    
        fetchPersonDueDetails(e);
        setEditSaleDetails(0);
        setEditPersonDue(1);
    }

    const closeEditPersonDue = () => {
        setPersonDueId(0);
        setPersonName();
        setPersonPhone();
        setPersonDueAmount();
        setEditSaleDetails(1);
        setEditPersonDue(0);
    }
 
    return(
        <div className='marketDuePage'> 
    
           <LeftPanel 
                tabName='market-due'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Sales Area'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Due</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Due</button>
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Assigned to</th>
                                    <th>Sales Area</th>
                                    <th>
                                        Person Due to
                                    </th>
                                    <th>Total Due (Tk)</th>
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.marketDueDate.substring(0,item.marketDueDate.length-9)}</td>
                                        <td>{item.marketDueAssignedTo}</td>
                                        <td>{item.marketDueSalesArea}</td>
                                        <td>
                                            {item.personDues.map((item,index) => {
                                                return(
                                                    <div key={index} style={{ display: "flex", justifyContent: "space-between" }}>
                                                        <span>{item.personDueName}</span>
                                                        <span>{item.personDuePhone}</span>
                                                        <span>Tk {item.personDueAmount}</span>
                                                    </div>
                                                )
                                            })}
                                       
                                       
                                        </td>
                                    
                                        <td>{item.marketDueAmount}</td>
                                        {editSale ===1 && 
                                        <td  style={{cursor:'pointer'}}>
                                           <button id='editDueButton' onClick={() => showEditSale(item.marketDueId)}>Edit</button> 
                                           <button onClick={() => showAddDue(item.marketDueId)} id='addDueButton'>Add Person</button> 
                                        </td>}
                                        
                                    </tr>
                                     
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addPersonDue === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddPersonDue}
                    />
                    <form id='modalContent' onSubmit={handleAddPersonDue}>
                        <div id='modalName'>Add Person Due</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Name:</div>
                                <input
                                    id='typeName'
                                    required
                                    placeholder='Type person name'
                                    onChange={(e) => setPersonName(e.target.value)}
                                    value={personName}
                                />
                            </div>
                            
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Phone:</div>
                                <input
                                    id='typeName'
                                    type='number'
                                    placeholder='Type phone no'
                                    required
                                    onChange={(e) => setPersonPhone(e.target.value)}
                                    value={personPhone}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        
                       
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Amount Due (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Type Due Here'
                                    required
                                    onChange={(e) => setPersonDueAmount(e.target.value)}
                                    value={personDueAmount}
                                />
                            </div>    
                            
                        </div>
                        
                        {isError && 
                            <div id='errorMsg'>Failed adding new sale! Please try again later.</div>
                        }
                        {isDueLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Due</button>
                    }
                       
                    </form>
                </div>
               </>
           }
             {
               editPersonDue === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modalEditPersonDue'>
                    {isEditLoading ? 
                    <Loading /> :
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            top:0,
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditPersonDue}
                    />
                    <form id='modalContent' onSubmit={handleEditPersonDue}>
                        <div id='modalName'>Edit Person Due</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Name:</div>
                                <input
                                    id='typeName'
                                    required
                                    placeholder='Type person name'
                                    onChange={(e) => setPersonName(e.target.value)}
                                    value={personName}
                                />
                            </div>
                            
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Phone:</div>
                                <input
                                    id='typeName'
                                    type='number'
                                    placeholder='Type phone no'
                                    required
                                    onChange={(e) => setPersonPhone(e.target.value)}
                                    value={personPhone}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        
                       
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Amount Due (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Type Due Here'
                                    required
                                    onChange={(e) => setPersonDueAmount(e.target.value)}
                                    value={personDueAmount}
                                />
                            </div>    
                            
                        </div>
                        
                        {isError && 
                            <div id='errorMsg'>Failed updating person due! Please try again later.</div>
                        }
                        {isDueLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Person Due</button>
                    }
                       
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeletePersonDue} >Delete</button>
                    }
                    </div>}
                </div>
               </>
           }
            {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={()=>setAddSale(0)}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Due</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Assigned to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Assigned Person Name'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales Area:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        
                       
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Due (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Type Due Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            
                        </div>
                        
                        {isError && 
                            <div id='errorMsg'>Failed adding new sale! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Due</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modalEditDue'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Due</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.substring(0,selectedDate.length-9)}</div>
                            </div>
                            <div id='name'>
                                <div id='header'>Assigned to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Assigned Person Name'
                                    required
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    value={assignedTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales Area:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSalesArea(e.target.value)}
                                    value={salesArea}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Total Due (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Total Price Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div> 
                           
                        </div>
                        <div id='separationLine' />
                       
                        <div id='modalName'>Person Due to</div>
                                {personDues.length > 0 && personDues.map((item,index) => {
                                    return(
                                    <div id='namePhone' key={index}>
                                        <div id='name' >
                                            <div id='personDueTitle'>Name: </div>
                                            <div id='personDueDesc'>{item.personDueName}</div>
                                            <div id='personDueTitle'>Phone: </div>
                                            <div id='personDueDesc'>{item.personDuePhone}</div>
                                            <div id='personDueTitle'>Amount (Tk): </div>
                                            <div id='personDueDesc'>{item.personDueAmount}</div>
        
                                        </div>    
                                        <div id='editDueButton' onClick={() => showEditPersonDue(item.personDueId)}>Edit</div>  
                                    </div>
                                    );
                                })}
                      

                        {isError && 
                            <div id='errorMsg'>Failed updating sale! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting sale! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Due</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default MarketDue;